import {
  DataGrid,
  GridApi,
  GridCellParams,
  GridCellValue,
  GridColDef,
} from "@material-ui/data-grid";
import React from "react";
import { useStore } from "../../../hooks/useStore";
import { useTranslation } from "../../../hooks/useTranslation";
import CustomPagination from "../../common/CustomPagination";
import { Tooltip } from "../../common/Tooltip";
import AcceptButton from "./AcceptButton";
import CancelButton from "./CancelButton";
import { useStyles } from "./PendingRequestDataStyles";

const PendingRequestData = () => {
  const classes = useStyles();
  const { pendingRequestStore } = useStore();
  const { t, BundleKey } = useTranslation();

  const getDataRow = (params: GridCellParams) => {
    const api: GridApi = params.api;
    const fields = api
      .getAllColumns()
      .map((c) => c.field)
      .filter((c) => c !== "__check__" && !!c);
    let thisRow: Record<string, GridCellValue> = {};
    fields.forEach((f) => {
      thisRow[f] = params.getValue(f);
    });
    return thisRow;
  };

  const columns: GridColDef[] = [
    {
      field: "id",
      hide: true,
    },
    {
      field: "lotNumber",
      headerClassName: "super-app-theme--header " + classes.cellLot,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_LOT),
      cellClassName: classes.cell + " " + classes.cellLot,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_LOT_TOOLTIP),
      disableColumnMenu: true,
      renderCell: (params) => <Tooltip bold value={params.value} />,
      sortable: false,
    },
    {
      field: "resident",
      headerClassName: "super-app-theme--header " + classes.cellResident,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_RESIDENT),
      cellClassName: classes.cell + " " + classes.cellResident,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_RESIDENT_TOOLTIP),
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Tooltip
          value={`${params.getValue("hostName") || ""} ${
            params.getValue("hostPhone") || ""
          }`}
        >
          <b>{params.getValue("hostName") || ""}</b>
          <span>{params.getValue("hostPhone") || ""}</span>
        </Tooltip>
      ),
    },

    {
      field: "guest",
      headerClassName: "super-app-theme--header " + classes.cellGuest,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_GUEST),
      cellClassName: classes.cell + " " + classes.cellGuest,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_GUEST_TOOLTIP),
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => <Tooltip bold value={params.value} />,
    },
    {
      field: "dateOfPass",
      headerClassName: "super-app-theme--header " + classes.dateOfPass,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_DATEOFPASS),
      cellClassName: classes.cell + " " + classes.dateOfPass,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_DATEOFPASS_TOOLTIP),
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => (
        <Tooltip
          value={`${params.getValue("beginDateOfPass") || ""} 
      ${params.getValue("beginTimeOfPass") || ""}-${
            params.getValue("endTimeOfPass") || ""
          }hs`}
        >
          <span>{params.getValue("beginDateOfPass") || ""}</span>
          <span>{`${params.getValue("beginTimeOfPass") || ""}-${
            params.getValue("endTimeOfPass") || ""
          }hs`}</span>
        </Tooltip>
      ),
    },
    {
      field: "comments",
      headerClassName: "super-app-theme--header " + classes.cellComments,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_COMMENTS),
      cellClassName: classes.cell + " " + classes.cellComments,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_COMMENTS_TOOLTIP),
      disableColumnMenu: true,
      sortable: false,
      renderCell: (params) => <Tooltip value={params.value} />,
    },
    {
      field: "action",
      headerClassName: "super-app-theme--header " + classes.cellActions,
      headerName: t(BundleKey.PENDINGREQUEST_GRID_HEAD_ACTIONS),
      cellClassName: classes.cell + " " + classes.cellActions,
      description: t(BundleKey.PENDINGREQUEST_GRID_HEAD_ACTIONS_TOOLTIP),
      sortable: false,
      disableClickEventBubbling: true,
      disableColumnMenu: true,
      renderCell: (params: any) => {
        return (
          <>
            <CancelButton rowData={getDataRow(params)} />
            <AcceptButton rowData={getDataRow(params)} />
          </>
        );
      },
    },
  ];

  return (
    <DataGrid
      className={classes.root}
      rows={pendingRequestStore.listPendingRequestFilter}
      columns={columns}
      pageSize={6}
      localeText={{ noRowsLabel: t(BundleKey.PENDINGREQUEST_NOTFOUND) }}
      disableSelectionOnClick
      components={{
        Pagination: CustomPagination,
      }}
    />
  );
};

export default PendingRequestData;
